import * as React from 'react';
import { useRef } from 'react';

import { AppRoutes } from 'constants/routes';

import ArrowLeft from 'assets/icons/arrows/arrow-left-16.svg';

import AssetPairLoading from 'basics/loaders/AssetPairLoading/AssetPairLoading';
import ContentPlaceholder from 'basics/loaders/ContentPlaceholder/ContentPlaceholder';
import { Bar, SkeletonStack } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import PageNavigation from 'components/PageNavigation';

import {
    BackButton,
    BackButtonWrapper,
    Divider,
    Header,
    MainBlock,
    MarketIdentityLoading,
    MarketSection,
} from './MarketPage.styled';

import AssetsDetailsLoading from '../../components/AssetsDetails/AssetsDetailsLoading';
import SidebarLoading from '../../components/Sidebar/SidebarLoading';

const MarketPageLoading = () => {
    const ref = useRef<HTMLElement>(null);
    return (
        <MainBlock>
            <BackButtonWrapper>
                <BackButton label="Back to markets" to={AppRoutes.page.vote}>
                    <ArrowLeft />
                </BackButton>
            </BackButtonWrapper>
            <PageNavigation
                anchors={['AMM stats', 'Market stats', 'Rewards', 'Voting Incentives'].map(
                    title => ({ title, ref }),
                )}
            />
            <SidebarLoading />
            <MarketSection>
                <Header>
                    <MarketIdentityLoading>
                        <AssetPairLoading large />
                        <SkeletonStack>
                            <Bar $width="18rem" $height="3.6rem" />
                            <Bar $width="16rem" />
                        </SkeletonStack>
                    </MarketIdentityLoading>
                    <Divider />
                    <ContentPlaceholder label="Loading market statistics">
                        <AssetsDetailsLoading />
                    </ContentPlaceholder>
                </Header>
            </MarketSection>
        </MainBlock>
    );
};

export default MarketPageLoading;
